import React from 'react'
import { TypeAnimation } from "react-type-animation";
import { generateCss, generateEvent, generateStyle } from '../../functions/sortableFunctions';

const TypingAnimation = ({ block, ...props }: any) => {

    const temp = [];

    if (block?.data?.sequence) {
        let n = block?.data?.sequence.length;
        for (let i = 0; i < n; i++) {
            temp.push(parseInt(block?.data?.sequence[i].delay));
            temp.push(block?.data?.sequence[i].value);
        }
        temp.push(parseInt(block?.data?.sequence[n - 1].delay));
    }

    return (
        React.createElement(
            block?.type,
            {
                key: block?.id,
                id: block?.id,
                style: generateStyle({
                    props: {
                        ...props,
                        block
                    }
                }),
                className: generateCss({
                    props: {
                        ...props,
                        block: block
                    },
                }),
                disabled: block?.data?.type == 'submit' ? props?.formik?.isSubmitting : null,
                onClick: block.events?.onClick ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onClick"
                    });
                } : null,
                onDoubleClick: block.events?.onDoubleClick ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onDoubleClick"
                    });
                } : null,
                onContextMenu: block.events?.onContextMenu ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onContextMenu"
                    });
                } : null,
                onMouseOver: block.events?.onMouseOver ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onMouseOver"
                    });
                } : null,
                onMouseLeave: block.events?.onMouseLeave ? async (e: any) => {
                    await generateEvent({
                        props: {
                            ...props,
                            block: block
                        },
                        e: e,
                        event: "onMouseLeave"
                    });
                } : null
            },
            <React.Fragment>
                <TypeAnimation
                    key={JSON.stringify(block?.data?.typingSpeed) + JSON.stringify(block?.data?.sequence)}	// Force Re-Render on Changing Text
                    sequence={temp}
                    speed={{ type: 'keyStrokeDelayInMs', value: parseInt(block?.data?.typingSpeed) }}
                    style={{ ...block?.style }}
                    repeat={Infinity}
                    wrapper="span"
                    className={block?.css}
                />
            </React.Fragment>
        )
    )
}

export default TypingAnimation;